import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCourses, StateStatus } from '@guryou/redux';

const useCourse = serviceId => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(state => state.courses.all);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getCourses());
    }
  }, [dispatch, status]);

  return { service: (data || []).find(x => x.id === +serviceId), status, version, entity };
};

export default useCourse;
